module.exports = __webpack_public_path__ + "img/search-mo.718f05ad.svg";